import React from "react";
import { Link } from "gatsby";
import { FaAngleLeft } from "@react-icons/all-files/fa/FaAngleLeft";
import { FaAngleRight } from "@react-icons/all-files/fa/FaAngleRight";

export default function NeighborPostLinks({ className, next, previous }) {
  return (
    <div className={`flex flex-row py-8 ${className}`}>
      {previous?.fields?.slug && (
        <Link
          to={previous.fields.slug}
          className="contents text-primary hover:text-secondary"
        >
          <FaAngleLeft className="m-1" />
          <div className="flex flex-col space-y-4">
            <p>Prev Post</p>
            <p>{previous.frontmatter.title}</p>
          </div>
        </Link>
      )}

      <div className="flex-grow w-1/3"></div>

      {next?.fields?.slug && (
        <Link
          to={next.fields.slug}
          className="contents text-primary hover:text-secondary"
        >
          <div className="flex flex-col text-right space-y-4">
            <p>Next Post</p>
            <p>{next.frontmatter.title}</p>
          </div>
          <FaAngleRight className="m-1" />
        </Link>
      )}
    </div>
  );
}
